import React, { useMemo, useState } from "react";
import { Button, Dropdown } from "antd";
import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import { ReactComponent as FilterIcon } from "../../../assets/Icons/filterIcon.svg";
import EllipsisTooltip from "../../EllipsisTooltip/EllipsisTooltip";
import "./CustomFilterDropdown.scss";

const CustomFilterDropdown = ({
  buttonLabel = "Category",
  options = [],
  onChange,
  defaultValue = null,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuClick = ({ key }) => {
    setSelectedValue(key);
    onChange?.(key);
    setIsOpen(false);
  };

  /* The cross sits inside the trigger button, so the click has to be stopped
     from bubbling or it would toggle the dropdown open again. */
  const handleClear = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setSelectedValue(null);
    onChange?.(null);
    setIsOpen(false);
  };

  const items = useMemo(
    () =>
      options.map((item) => ({
        key: String(item.value),
        label: <EllipsisTooltip text={item.label || ""} />,
      })),
    [options],
  );

  /* Show what is actually filtered, but stay quiet on the default option -
     a chip reading "All" is noise rather than information. */
  const activeLabel = useMemo(() => {
    if (selectedValue == null || String(selectedValue) === String(defaultValue))
      return null;
    return options.find((o) => String(o.value) === String(selectedValue))?.label;
  }, [options, selectedValue, defaultValue]);

  return (
    <Dropdown
      trigger={["click"]}
      placement="bottomRight"
      open={isOpen}
      onOpenChange={setIsOpen}
      overlayClassName="custom-dropdown-wrapper"
      menu={{
        items,
        onClick: handleMenuClick,
        selectedKeys: [String(selectedValue)],
      }}
    >
      <Button
        className={`dropdown-button${isOpen ? " active" : ""}${
          activeLabel ? " has-value" : ""
        }`}
      >
        <FilterIcon className="filter-icon" />
        <span>{buttonLabel}</span>
        {activeLabel && (
          <span className="dropdown-button__value">
            <span className="dropdown-button__value-text">{activeLabel}</span>
            <CloseOutlined
              className="dropdown-button__clear"
              title="Clear filter"
              onClick={handleClear}
            />
          </span>
        )}
        <DownOutlined className="dropdown-button__chevron" />
      </Button>
    </Dropdown>
  );
};

export default CustomFilterDropdown;
